import { getTokenFromUrl } from '@shared/utils'
import { useLocation } from 'react-router-dom'

export const useAppLocation = () => {
  const location = useLocation()
  const token = getTokenFromUrl()

  return {
    ...location,
    pathname: location.pathname.replace(`/apps/crm/${token}`, '')
  }
}
